(function(){
    angular
        .module('app')
        .directive('ngCalendarioaus', calendarioaus);

        calendarioaus.$inject = ['$timeout','$uibModal','CalendarioService','uiCalendarConfig'];
        function calendarioaus($timeout,$uibModal,CalendarioService,uiCalendarConfig){
            return {
            templateUrl:'/backend/app/views/calendarioaus.html',
            scope: { url:"=",control:"=",calendar:"=" },
            //require: 'ngModel',
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                	console.log(scope);
                    scope.events = [];
                    scope.eventSource = [{
                        //events:scope.events,
                        url: scope.url,
                        className: 'gcal-event',           // an option!
                        //currentTimezone: 'America/Chicago' // an option!
                    }];


                    scope.uiConfig = {
                      calendar:{
                        //height: 450,
                        editable: false,
                        header:{
                          left: 'title',
                          center: '',
                          right: 'today prev,next'
                        },
                        firstDay:1,
                        
                        eventClick: function(date, jsEvent, view){
                        	//console.log(date);
                        	//console.log(jsEvent);
                        	//console.log(view);
                            //scope.calendar.fullCalendar('refetchEvents');
                            scope.initPopup(date);
                            //console.log(date.id);
                        },
                        eventDrop: scope.calendarClick,
                        eventResize: scope.calendarClick,
                        eventRender: scope.calendarClick,
                        viewRender: function(view, element) {
                            scope.calendar = view.calendar;
                            //$log.debug("View Changed: ", view.visStart, view.visEnd, view.start, view.end);
                        }
                      }
                    };
                    scope.contentCreateModal = "";
                    scope.initPopup = function(date){
                    	scope.msgokModal = "";
		                scope.contentCreateModal = $uibModal.open({
		                      animation: true,
		                      ariaLabelledBy: 'modal-title-top',
		                      ariaDescribedBy: 'modal-body-top',
		                      templateUrl: 'contentcalendarioaus.html',
		                      size: 'lg',
		                      controller: function($scope) {
		                      	$scope.date = date;
		                        $scope.okForm = function(){
		                            
		                            scope.contentCreateModal.close();
		                        }
		                        $scope.koForm = function(){
		                            scope.contentCreateModal.close();
		                        }
		                      }
		                });
                    }
                    scope.contentCreateAdd = "";
                    scope.addCalaus = function(){
                    	 scope.contentCreateAdd = $uibModal.open({
		                      animation: true,
		                      ariaLabelledBy: 'modal-title-top',
		                      ariaDescribedBy: 'modal-body-top',
		                      templateUrl: 'addcal.html',
		                      size: 'lg',
		                      controller: function($scope) {
		                      	$scope.control = scope.control;
		                      	console.log($scope.control);
		                        $scope.okForm = function(){
		                        	console.log(scope.control);
		                            CalendarioService.saveCalendarioAus(scope.control.camposActual,function(){
		                            	//scope.calendar.fullCalendar('refetchEvents');
                                        scope.calendar.refetchEvents();
		                            	scope.contentCreateAdd.close();
		                            });
		                        }
		                        $scope.koForm = function(){
		                            scope.contentCreateAdd.close();
		                        }
		                      }
		                });
                    }

                    scope.calendarClick = function( date, jsEvent, view){
                        /*console.log(date);
                        console.log(jsEvent);
                        console.log(view);*/
                    }
                   
                });
            }
          }
      }
})();